var _path, _path2, _path3, _path4, _circle, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocalIdIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55589 0.484816C7.55589 0.42591 7.60364 0.378156 7.66255 0.378156H10.5714C10.6304 0.378156 10.6781 0.425909 10.6781 0.484816V2.9089C10.6781 3.77107 9.97917 4.47 9.117 4.47C8.25482 4.47 7.55589 3.77107 7.55589 2.9089V0.484816Z",
    fill: "#C8E2F5",
    stroke: "#303030",
    strokeWidth: 0.756313
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4334 2.42578L16.0906 2.53536C16.6187 2.54559 17.0414 2.97662 17.0414 3.50481V13.212C17.0414 13.7505 16.6026 14.1859 16.0641 14.1816L1.96165 14.069C1.42917 14.0648 0.999756 13.6319 0.999756 13.0994V3.39541C0.999756 2.8599 1.43387 2.42578 1.96939 2.42578H7.42058",
    stroke: "#303030",
    strokeWidth: 0.727224
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59766 7.03125H14.6882",
    stroke: "#303030",
    strokeWidth: 0.727224,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59766 9.69531H14.6882",
    stroke: "#303030",
    strokeWidth: 0.727224,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.23982,
    cy: 7.02889,
    r: 1.3187,
    fill: "#C8E2F5",
    stroke: "#303030",
    strokeWidth: 0.756313
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05884 10.666V10.666C3.05884 9.46114 4.03561 8.48438 5.24051 8.48438V8.48438C6.44541 8.48438 7.42218 9.46114 7.42218 10.666V10.666",
    stroke: "#303030",
    strokeWidth: 0.727224,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalIdIcon);
export default __webpack_public_path__ + "static/media/localIDIcon.a594ab228ee17466a7b923879f83f832.svg";
export { ForwardRef as ReactComponent };